import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { formatTime } from '../Utility/function'
import { stringY } from '../Utility/dateTime';
import { db } from '../db/firestore';
import { initialMember } from '../configs';

const initialState = {
    members:[], // 
    modal_Member:false,
    newMember:initialMember,
    modal_SortMember:false,
    modal_NewMember:false,
    sort_Member:{id:1,name:'แต้ม (มากไปน้อย)'},
    modal_SearchMember:false,
    memberBill:[],
    memberBillId:'',
    currentMember:initialMember
}

export const fetchMember = createAsyncThunk(
  'member/fetchMember', async (token) => {
    let data = []
    const memberRef = db.collection('member').where('shopId','==',token);
    await memberRef.get().then((docs)=>{
      docs.forEach((doc)=>{
        const { bought = [], timestamp = new Date(), lastTime = new Date(), ...rest } = doc.data();
        const thisYear = stringY(new Date());
        const arr = bought.filter(a=>a.year === thisYear);
        const totalBuy = arr.reduce((a, b) => a + ((b.buy) || 0), 0);
        data.push({
          ...rest,
          id: doc.id,
          timestamp:formatTime(timestamp),
          lastTime:formatTime(lastTime),
          totalBuy
        })})
    })
    return data;
});

export const fetchMemberBill = createAsyncThunk(
  'member/fetchMemberBill', async (token) => {
  let res = []
        try {
          const querySnapshot = await db.collection('bill') // Replace with your actual collection name
            .where('member.id', '==', token) // Replace '999' with the desired member ID
            .orderBy('dateTime', 'desc') // Replace 'timestampField' with your actual timestamp field
            .limit(100) // น่าจะ cover 1 ปี
            .get();
      
          // Loop through the documents in the query snapshot
          querySnapshot.forEach((documentSnapshot) => {
            // Access the document data
            res.push({...documentSnapshot.data(),id:documentSnapshot.id,dateTime:formatTime(documentSnapshot.data().dateTime)})
            // console.log('Document data:', data);
          });
      
        } catch (error) {
          console.error('Error querying documents:', error);
        }
        return {data: res.filter(a=>!a?.void), memberBillId:token}
});

export const deleteMember = createAsyncThunk(
  'member/deleteMember', async (id) => {
  await db.collection('member').doc(id).delete()
  return id;
});

export const memberSlice = createSlice({
  name: 'member',
  initialState,
  reducers: {
    clearMember: state => {
      state.members = [];
      state.memberBill = [];
    },
    addNewMember: (state, action)=>{
      const { bought = [], timestamp = new Date(), lastTime = new Date(), ...rest } = action.payload;
        const thisYear = stringY(new Date());
        const arr = bought.filter(a=>a.year === thisYear);
        const totalBuy = arr.reduce((a, b) => a + ((b.buy) || 0), 0);
        const obj = {
          ...rest,
          timestamp:formatTime(timestamp),
          lastTime:formatTime(lastTime),
          totalBuy
        };
     
        state.members.push(obj)
        state.currentMember = action.payload;
        state.newMember = initialMember;
    },
    updateCurrentMember: (state, action)=> {
      state.currentMember = action.payload
    },
    updateFieldNormalMember: (state, action)=> {
      const { id, updateFields } = action.payload;
      const item = state.members.find(item => item.id === id);

      if (item) {
        Object.assign(item, updateFields); // Directly update fields (Immer handles immutability)
      }
    },
    updateModal_NewMember: state => {
      state.modal_NewMember = !state.modal_NewMember
    },
    updateNewMember: (state, action)=> {
        state.newMember = action.payload
    },
    updateModal_SearchMember: (state, action)=> {
      state.modal_SearchMember = action.payload
  },
    clearNewMember: state => {
      state.newMember = initialMember
      state.modal_NewMember = false
    },
    updateSort_Member: (state, action) => {
      state.sort_Member = action.payload
      state.modal_SortMember = !state.modal_SortMember
    },
    updateModal_SortMember: state => {
      state.modal_SortMember = !state.modal_SortMember
    },
  },
  extraReducers: builder => {
    builder.addCase(deleteMember.pending, state => {
      state.modal_Member = true
    })
    builder.addCase(deleteMember.fulfilled, (state, action) => {
        const index = state.members.findIndex(a => a.id === action.payload);
        state.members.splice(index, 1); // Directly remove the item (Immer handles immutability)
        state.modal_Member = false
    })
    builder.addCase(deleteMember.rejected, state => {
        state.modal_Member = false
    })
    builder.addCase(fetchMember.pending, state => {
      state.modal_Member = true
    })
    builder.addCase(fetchMember.fulfilled, (state, action) => {
      state.members = action.payload
      state.modal_Member = false
    })
    builder.addCase(fetchMember.rejected, state => {
      state.modal_Member = false
    })
    builder.addCase(fetchMemberBill.pending, state => {
      state.modal_Member = true
    })
    builder.addCase(fetchMemberBill.fulfilled, (state, action) => {
      const { data, memberBillId } = action.payload;
      state.memberBill = data
      state.memberBillId = memberBillId
      state.modal_Member = false
    })
    builder.addCase(fetchMemberBill.rejected, state => {
      state.modal_Member = false
    })
  }
})

export const { updateNewMember, clearNewMember, 
  updateSort_Member,
  updateModal_SortMember, updateModal_NewMember, 
  updateModal_SearchMember, clearMember, updateFieldNormalMember,
  updateCurrentMember, addNewMember
} = memberSlice.actions

export default memberSlice.reducer